import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ProductCard from "../product_card/product_card";
import styles from "./products_list.module.css";
import {
  WIDTH_1, WIDTH_2, WIDTH_3, WIDTH_4,
  START_CARDS_MORE_1200_PX, START_CARDS_MORE_768_PX, START_CARDS_MORE_540_PX, START_CARDS_MORE_320_PX,
  ADD_CARDS_MORE_1200_PX, ADD_CARDS_MORE_768_PX, ADD_CARDS_MORE_540_PX, ADD_CARDS_MORE_320_PX
} from "../../utils/constants";
import { useResize } from "../../hooks/use-resize";
import { getQuantityCards } from "../../utils/util_functions";

const ProductsList = ({ actualProducts }) => {

  const currWidth = useResize();


  const [countsCards, setCountsCards] = useState(getQuantityCards(
    currWidth, WIDTH_1, WIDTH_2, WIDTH_3, WIDTH_4,
    START_CARDS_MORE_320_PX, ADD_CARDS_MORE_320_PX,
    START_CARDS_MORE_540_PX, ADD_CARDS_MORE_540_PX,
    START_CARDS_MORE_768_PX, ADD_CARDS_MORE_768_PX,
    START_CARDS_MORE_1200_PX, ADD_CARDS_MORE_1200_PX
  ));
  const [count, setCount] = useState(countsCards.quantityStart);
  const [isButton, setIsButton] = useState(false);


  const addProducts = (increment, arrLength) => {
    let newCount = count;
    newCount += increment;
    setCount(newCount);
    controlButton(arrLength, newCount);
  }

  const controlButton = (arrLength, length) => {
    arrLength > length ? setIsButton(true) : setIsButton(false);
  }

  const handleClickMore = () => {
    addProducts(countsCards.quantityAdd, actualProducts.length);
  }

  useEffect(() => {
    setIsButton(actualProducts.length > countsCards.quantityStart);
    setCount(countsCards.quantityStart);
    // eslint-disable-next-line
  }, [actualProducts,]);


  return (
    <>
      <ul className={styles.list}>
        {
          actualProducts.slice(0, count).map(product =>
            <li key={product.id}>
              <Link to={product.path}
                className={styles.productCard}
              >
                <ProductCard product={product} />
              </Link>
            </li>
          )
        }
      </ul>
      {
        isButton &&
        <button
          className={styles.addButton}
          onClick={handleClickMore}
        >
          Ещё
        </button>
      }
    </>
  );
}

export default ProductsList;
